import { FolderDto } from "@braoshzmvavz/picnube-common";
import {
  Button,
  getTreeExpandedState,
  Text,
  TreeNodeData,
  useTree
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { HiArrowRight } from "react-icons/hi";
import { useAppSelector } from "src/app/hooks";
import useApi from "src/services/useApi";
import { selectCurrentSpace } from "src/state/profile/profileSlice";
import FolderTree from "../folder/FolderTree";

export interface MoveFolderModalProps {
  foldersToMove: FolderDto[];
  onMove: (folderIds: string[], targetFolderId: string) => void;
  loading: boolean;
}

export default function MoveFolderModal(props: MoveFolderModalProps) {
  const [filteredFolders, setFilteredFolders] = useState<FolderDto[]>([]);
  const [selectedFolderId, setSelectedFolderId] = useState<string>("");

  const currentSpace = useAppSelector(selectCurrentSpace);
  const [spaceFolderTree, setSpaceFolderTree] = useState<any[]>([]);

  const [expandedFolderIds, setExpandedFolderIds] = useState<string[]>([]);

  const { fetchSpaceFolderTree } = useApi();

  const tree = useTree({
    multiple: false,
  });

  // Handle node selection
  const handleNodeSelect = (value: string) => {
    setSelectedFolderId(value);
  };

  const filterCurrentFolderOutOfNodeList = (nodeList: TreeNodeData[]) => {
    const foldersToMoveIds = props.foldersToMove.map((folder) => folder.id);
    if (!foldersToMoveIds) return nodeList;

    // Remove current folder from the list
    const filteredNodeList = [];

    nodeList.forEach((node) => {
      if (foldersToMoveIds.includes(node.value)) {
        console.log("currentFolderId found in nodeList");
        return;
      }
      filteredNodeList.push({
        ...node,
        //expanded: node.value === props.currentFolder.parentId,
        children: filterCurrentFolderOutOfNodeList(node.children),
      });
    });

    return filteredNodeList;
  };

  useEffect(() => {
    fetchSpaceFolderTree(currentSpace.id).then((response: TreeNodeData[]) => {
      const filteredNodeList = filterCurrentFolderOutOfNodeList(response);

      setSpaceFolderTree(filteredNodeList);
    });

    const expandedFolderIds = props.foldersToMove[0].path
      .split(";")
      .map((folder: string) => folder.split(":")[0])
      .filter((folder: string) => folder !== "");
    console.log("expandedFolderIds", expandedFolderIds);
    setExpandedFolderIds(expandedFolderIds);
  }, []);

  useEffect(() => {
    if (!spaceFolderTree) return;

    tree.setExpandedState(
      getTreeExpandedState(spaceFolderTree, [
        "0ec229d5-a6ed-4d54-8546-09169742306c",
      ])
    );
  }, [spaceFolderTree]);

  /*
  useEffect(() => {
    // Filter out the current folder and its descendants to prevent circular references
    const filterFolders = () => {
      const currentFolderId = props.currentFolder?.id;
      if (!currentFolderId) return;

      const filtered = props.availableFolders.filter((folder) => {
        // Don't allow moving to the same folder
        if (folder.id === currentFolderId) return false;

        // Don't allow moving to a descendant folder (would create circular reference)
        if (isDescendant(folder.id, currentFolderId, props.availableFolders))
          return false;

        return true;
      });

      setFilteredFolders(filtered);
    };

    filterFolders();
  }, [props.currentFolder, props.availableFolders]);*/

  const isDescendant = (
    potentialParentId: string,
    currentFolderId: string,
    allFolders: FolderDto[]
  ): boolean => {
    const findFolder = (id: string) => allFolders.find((f) => f.id === id);
    const currentFolder = findFolder(currentFolderId);

    if (!currentFolder) return false;

    // Check if the potential parent is a direct parent
    if (currentFolder.parentId === potentialParentId) return true;

    // Recursively check parent folders
    if (currentFolder.parentId) {
      return isDescendant(
        potentialParentId,
        currentFolder.parentId,
        allFolders
      );
    }

    return false;
  };

  /*const getFolderDisplayName = (folder: FolderDto) => {
    if (!folder.parentId) {
      return `${folder.name} (Root)`;
    }

    const parent = props.availableFolders.find((f) => f.id === folder.parentId);
    if (parent) {
      return `${folder.name} → ${parent.name}`;
    }

    return folder.name;
  };*/

  const onFolderSelected = (folderId: string) => {
    setSelectedFolderId(folderId);
  };

  return (
    <div className="flex flex-col gap-4 w-full p-4">
      <div className="text-center mb-4">
        <Text size="lg" fw={500}>
          Move{" "}
          {props.foldersToMove.length > 1
            ? `${props.foldersToMove.length} folders`
            : `"${props.foldersToMove[0]?.name}"`}{" "}
          to:
        </Text>
        <Text size="sm" c="dimmed" mt={4}>
          Select the destination folder where you want to move this folder
        </Text>
      </div>

      <div className="flex flex-col gap-4">
        <div>
          <Text size="sm" fw={500} mb={8}>
            Select Destination Folder
          </Text>
          <div className="border border-gray-200 dark:border-grey-700 rounded-lg bg-gray-50 dark:bg-grey-900 max-h-64 overflow-y-auto">
            <FolderTree
              data={spaceFolderTree}
              defaultSelectedFolderId={props.foldersToMove[0]?.parentId}
              defaultExpandedFolderIds={expandedFolderIds}
              onFolderClick={onFolderSelected}
            />
          </div>
        </div>

        {/*selectedFolderId && (
          <div className="flex items-center justify-center gap-2 p-3 bg-gray-50 dark:bg-gray-800 rounded-md">
            <Text size="sm" c="dimmed">
              {props.currentFolder?.name}
            </Text>
            <HiArrowRight size={16} className="text-gray-400" />
            <Text size="sm" c="dimmed">
              {filteredFolders.find((f) => f.id === selectedFolderId)?.name}
            </Text>
          </div>
        )*/}

        <Button
          className="w-full mt-3"
          onClick={() =>
            props.onMove(
              props.foldersToMove.map((folder) => folder.id),
              selectedFolderId
            )
          }
          leftSection={<HiArrowRight />}
          loading={props.loading}
          disabled={!selectedFolderId}
        >
          Move Folder
        </Button>
      </div>
    </div>
  );
}
